import { compose } from 'recompose';
import { Switch, Route } from 'react-router-dom';
import withAuthProtection from 'hoc/withAuthProtection';
import withPermissionProtection from 'hoc/withPermissionProtection';
import Home from './Home';
import New from './New';

const W4s = ({ offer = false }) => {
  const prefix = offer ? '/offer' : '';
  return (
    <Switch>
      <Route path={`${prefix}/w4s/new/federal`} exact={true} component={New} />
      <Route path={`${prefix}/w4s/new/state`} exact={true} component={New} />
      <Route path={`${prefix}/td1s/new/federal`} exact={true} component={New} />
      <Route
        path={`${prefix}/td1s/new/province`}
        exact={true}
        component={New}
      />
      <Route component={props => <Home prefix={prefix} {...props} />} />
    </Switch>
  );
};

export default compose(
  withAuthProtection(),
  withPermissionProtection(['payroll_employee:edit']),
)(W4s);
